// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9b-3";
export var contentContainer = "_9b-0";
export var editorContainer = "_9b-1";
export var quillInputForm = "_9b-2";
export var zoneDivider = "_9b-4";